module.exports = __webpack_public_path__ + "img/filter-icon.e7cb768e.svg";